import * as WebBrowser from 'expo-web-browser';
import { partnerSupplierAppURL } from '@/utils/environment';
import { Platform } from 'react-native';

/**
 * To test this locally on mobile (simulator), the x-forwarded-host header
 * in the mobile web browser needs to be forced to 'restaurants-staging.pepper.app'
 * This can be done by replacing `host` at the top of `getThemedProps`
 * in `_document.page.tsx` like so:
 * ```
 *    const host = 'restaurants-staging.pepper.app';
 * ```
 * The web server (`yarn web:dev`) must be running along with simulator (`yarn start`)
 */
export const FTNI_HOSTNAME = __DEV__
  ? 'http://localhost:3000'
  : partnerSupplierAppURL;

interface Props {
  orderInvoiceNumbers: string[];
  orderInvoiceUUIDs: string[];
  restaurantUUID: string;
  supplierUUID: string;
  userUUID: string;
}

export const openFTNIDirectFormInBrowser = async ({
  orderInvoiceNumbers,
  orderInvoiceUUIDs,
  restaurantUUID,
  supplierUUID,
  userUUID,
}: Props) => {
  const url = `${FTNI_HOSTNAME}/ftni/form?userUUID=${userUUID}&supplierUUID=${supplierUUID}&restaurantUUID=${restaurantUUID}&orderInvoiceNumbers=${orderInvoiceNumbers}&orderInvoiceUUIDs=${orderInvoiceUUIDs.join(
    ',',
  )}`;

  if (Platform.OS === 'web') {
    return await WebBrowser.openAuthSessionAsync(url);
  } else {
    return await WebBrowser.openBrowserAsync(url, {
      dismissButtonStyle: 'done',
    });
  }
};
